import React from "react";
import { Typography, Box, Chip } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  titleColor?: string;
  previewText?: string;
  titleBadge?: string;
}

export const PreviewChip: React.FC<{ label: string }> = ({ label }) => (
  <Chip
    label={label}
    size="medium"
    sx={{
      alignSelf: "center",
      fontWeight: 400,
      backgroundColor: "#FEF6EE",
      border: "1px solid #F9DBAF",
      height: 25,
      "& .MuiChip-label": { color: "#B93815", fontSize: "14px" },
    }}
  />
);

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  titleColor,
  previewText,
  titleBadge,
}) => {
  return (
    <Box pb={4}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Typography
          variant="h4"
          fontSize={"32px !important"}
          lineHeight={"42px !important"}
          fontWeight="semi-bold"
          sx={{ color: titleColor }}
        >
          {title}
        </Typography>
        {previewText && <PreviewChip label={previewText} />}
        {titleBadge && (
          <Chip
            icon={
              <AssignmentOutlinedIcon
                style={{ width: 14, height: 14, marginLeft: 12 }}
              />
            }
            label={titleBadge}
            size="medium"
            sx={{
              alignSelf: "center",
              fontWeight: 400,
              backgroundColor: "#fff",
              border: "1px solid #D0D5DD",
              "& .MuiChip-label": { color: "#344054", fontSize: "14px" },
              "& .MuiChip-icon path": { fill: "#667085" },
            }}
          />
        )}
      </Box>
      {subtitle && <Typography variant="body2">{subtitle}</Typography>}
    </Box>
  );
};
